export default function isEqualArray<T>(a: T[], b: T[]) {
  // if length is not equal
  if (a.length !== b.length) return false;
  // comapring each element of array
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
  return true;
}
